export default {
    date: value => {
        const date = new Date(value);
        return date.toLocaleString(["fr-FR"], {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour: "numeric",
            minute: "numeric"
        });
    },
    date_dmy: value => {
        let d = new Date(value),
            day = "" + d.getDate(),
            month = d.toLocaleString("fr-FR", { month: "long" }),
            year = d.getFullYear();

        if (day.length < 2) day = "0" + day;

        return [day, month, year].join(" ");
    },
    date_dm: value => {
        let d = new Date(value),
            day = "" + d.getDate(),
            month = d.toLocaleString("fr-FR", { month: "long" });

        if (day.length < 2) day = "0" + day;

        return [day, month].join(" ");
    },
    date_dmy_t: value => {
        let d = new Date(value),
            day = "" + d.getDate(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return [day, month, year].join("-");
    },
    date_dmyhm: value => {
        let d = new Date(value),
            day = "" + d.getDate(),
            month = "" + (d.getMonth() + 1),
            year = d.getFullYear();

        if (month.length < 2) month = "0" + month;
        if (day.length < 2) day = "0" + day;

        return (
            [day, month, year].join("/") +
      " " +
      d.toLocaleTimeString(navigator.language, {
          hour: "2-digit",
          minute: "2-digit"
      })
        );
    },
    to_hm: value => {
        let hours = Math.floor(value / 60);
        let minutes = value % 60;
        let hour = hours > 1 ? hours + " heures " : hours + " heure ";
        let min = minutes > 0 ? minutes + " minutes" : "";
        return hour + min;
    },
    to_hms: value => {
        let hrs = Math.floor(value / 3600);
        let min = Math.floor((value - hrs * 3600) / 60);
        let seconds = value - hrs * 3600 - min * 60;
        seconds = Math.round(seconds * 100) / 100;

        let result = hrs < 10 ? "0" + hrs : hrs;
        result += "h " + (min < 10 ? "0" + min : min);
        result += "m " + (seconds < 10 ? "0s" + seconds : seconds + "s");
        return result;
    }
};
